/* eslint-disable import/no-anonymous-default-export */
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ShareIcon from "@mui/icons-material/Share";
import AddIcon from "@mui/icons-material/Add";
import GroupIcon from "@mui/icons-material/Group";
import CheckIcon from "@mui/icons-material/Check";
import LocalActivityIcon from "@mui/icons-material/LocalActivity";
import HailIcon from "@mui/icons-material/Hail";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PowerSettingsNewOutlinedIcon from "@mui/icons-material/PowerSettingsNewOutlined";

export default [
  {
    name: "خانه",
    path: `/paths`,
    icon: HomeOutlinedIcon,
  },
  { type: "line" },
  {
    name: "کیف پول",
    path: `/wallets`,
    icon: AccountBalanceWalletOutlinedIcon,
  },
  {
    name: "معرفی به دوستان",
    path: `/referral`,
    icon: ShareIcon,
  },
  {
    name: "پیشنهاد مسیر",
    path: `/survey`,
    icon: AddIcon,
  },
  { type: "line" },
  {
    name: "همپیمایی",
    path: `/ridesharing`,
    icon: GroupIcon,
  },
  { type: "line" },
  {
    name: "پرداخت لحظه اخری",
    path: `/no-path-1`,
    icon: CheckIcon,
  },
  {
    name: "تاریخچه لحظه اخری",
    path: `/no-path-2`,
    icon: CheckIcon,
  },
  {
    name: "تاریخچه سفارش ها",
    path: `/tickets`,
    icon: LocalActivityIcon,
  },
  { type: "line" },
  {
    name: "دربستی",
    path: `/hiring`,
    icon: HailIcon,
  },
  {
    name: "تاریخچه دربستی",
    path: `/hiring-list`,
    icon: FormatListBulletedIcon,
  },
  { type: "line" },
  {
    name: "مکان های من",
    path: `/addresses`,
    icon: LocationOnIcon,
  },
  { type: "line" },
  {
    name: "راهنمای استفاده",
    path: `/howitworks`,
    icon: QuestionMarkIcon,
    websiteAddress: "https://behamrah.ir",
  },
  {
    name: "سوالات متداول",
    path: `/faq`,
    icon: InfoOutlinedIcon,
    websiteAddress: "https://behamrah.ir",
  },
  {
    name: "پشتیبانی",
    path: `support`,
    icon: CallOutlinedIcon,
    websiteAddress: "https://behamrah.ir",
  },
  { type: "line" },
  {
    name: "تنظیمات",
    path: `/profile`,
    icon: SettingsOutlinedIcon,
  },
  // {
  //   name: "خروج",
  //   path: `/logout`,
  //   icon: PowerSettingsNewOutlinedIcon,
  // },
];
